import { useInfiniteQuery } from "@tanstack/react-query";
import { getSoftwaresForSelect } from "./api";
import { softwaresForSelect } from "./key";
import { transformSoftwareToOption } from "./selector";
import type { Software, SoftwaresResponse } from "./type";

export const useSoftwaresForSelect = (
  searchText: string,
  disabledSoftwareIds: Set<string>,
) => {
  const result = useInfiniteQuery<SoftwaresResponse>({
    queryKey: softwaresForSelect.softwares(searchText),
    queryFn: ({ pageParam }) =>
      getSoftwaresForSelect(searchText, pageParam as number),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.maxPage ? lastPage.page + 1 : undefined;
    },
  });

  return {
    ...result,
    data:
      result.data?.pages.flatMap((page: SoftwaresResponse) =>
        page.items.map((software: Software) =>
          transformSoftwareToOption(software, disabledSoftwareIds),
        ),
      ) || [],
    fetchNextPage: result.fetchNextPage,
    hasNextPage: result.hasNextPage,
    isFetching: result.isFetching,
  };
};
